import { ROUTES, getRoutePath } from "../Resources/routes";
import LangNav from "./LangNav";
import TopMenu from "./TopMenu";

function PageHeader({ langName }) {
    const lang = langName;

    return (
        <div className="page-hdr">
            <div className="logo">
                <a href={getRoutePath(ROUTES.HOME, lang)}>
                    <img src="/images/logo.png" alt="Logo" />
                </a>
            </div>
            <LangNav langName={lang} />
            <TopMenu langName={lang} />
        </div>
    );
}

export default PageHeader;
